export const environment = {
  production: true,
  apiUrl: 'https://assistant-mobile-gateway.hellomovertis.com',
  authUrl: { url: 'https://api-assistant.hellomovertis.com/gateway-auth' },
  apiGateway: { url: 'https://assistant-gateway-chat.hellomovertis.com' },
  apiGatewayChat: { url: 'https://assistant-gateway-chat.hellomovertis.com' },
  apiGatewayRoutes: { url: 'https://assistant-gateway-routes.hellomovertis.com' },
  apiGatewayTrips: { url: 'https://assistant-gateway-trips.hellomovertis.com' },
  apiTaco360: { url: 'https://api-assistant.hellomovertis.com/taco360' },
  apiMovertis: { url: 'https://devapi.hellomovertis.com' },
  apiGatewayGeocoder: { url: 'https://gateway-geocoder.hellomovertis.com' },
  apiJavaBackendUrl: { url: 'https://api-assistant.hellomovertis.com/core' },
  apiGatewayCosts: { url: 'https://assistant-gateway-costs.hellomovertis.com' },
  apiBuscontrol: { url: 'https://nimbus.wialon.com/api' },
  apiCarpooling: { url: 'https://api-assistant.hellomovertis.com/carpooling' },
  apiForms: { url: 'https://api-assistant.hellomovertis.com/core/forms/app' },
  apiNotifications: { url: 'https://api-assistant.hellomovertis.com/notifications' },
};
export const traceTargets = [
  'localhost',
  'https://assistant-mobile-gateway.hellomovertis.com',
  'https://api-assistant.hellomovertis.com',
  'https://assistant-gateway-chat.hellomovertis.com',
  'https://assistant-gateway-routes.hellomovertis.com',
  'https://assistant-gateway-trips.hellomovertis.com',
  'https://devapi.hellomovertis.com',
  'https://gateway-geocoder.hellomovertis.com',
  'https://assistant-gateway-costs.hellomovertis.com',
  'https://nimbus.wialon.com',
];
